(function () {
  'use strict';

  if (window.DevidCommerceAnalytics) return;

  var SESSION_KEY = 'devid_commerce_session_id';
  var SEARCH_KEY = 'devid_last_search_query';
  var ATTRIBUTION_KEY = 'devid_commerce_attribution_v2';
  var ATTRIBUTION_TTL = 30 * 60 * 1000;

  function sessionId() {
    try {
      var current = window.sessionStorage.getItem(SESSION_KEY);
      if (current) return current;
      current = 'dl_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
      window.sessionStorage.setItem(SESSION_KEY, current);
      return current;
    } catch (error) {
      return 'dl_ephemeral';
    }
  }

  function clean(value) {
    if (value === null || value === undefined) return '';
    return String(value).slice(0, 180);
  }

  function safeSearchQuery(value) {
    var query = clean(value).trim();
    if (!query) return '';
    if (/\b[^\s@]+@[^\s@]+\.[^\s@]+\b/i.test(query)) return '[redacted_email]';
    if (/\b\+?\d[\d\s().-]{8,}\d\b/.test(query)) return '[redacted_number]';
    return query;
  }

  function pageType() {
    var bodyType = document.body && document.body.dataset ? (document.body.dataset.template || '') : '';
    if (bodyType) return clean(bodyType);

    try {
      var shopifyType = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page
        ? ShopifyAnalytics.meta.page.pageType
        : '';
      if (shopifyType) return clean(shopifyType);
    } catch (error) {}

    var path = window.location.pathname || '/';
    if (/\/products\//.test(path)) return 'product';
    if (/\/collections\//.test(path)) return 'collection';
    if (/\/search/.test(path)) return 'search';
    if (/\/cart/.test(path)) return 'cart';
    if (/\/account/.test(path)) return 'account';
    if (path === '/' || path === '') return 'index';
    return 'other';
  }

  function customerState() {
    var shell = document.querySelector('[data-devid-wishlist-shell]');
    if (shell) return clean(shell.getAttribute('data-customer-state') || 'unknown');
    return 'unknown';
  }

  function attribution() {
    try {
      var raw = window.sessionStorage.getItem(ATTRIBUTION_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.surface || !parsed.at) return null;
      if (Date.now() - parsed.at > ATTRIBUTION_TTL) {
        window.sessionStorage.removeItem(ATTRIBUTION_KEY);
        return null;
      }
      return parsed;
    } catch (error) {
      return null;
    }
  }

  function rememberAttribution(surface, detail) {
    if (!surface) return;
    var context = {
      surface: clean(surface),
      handle: clean(detail && detail.handle ? detail.handle : ''),
      destination: clean(detail && detail.destination ? detail.destination : ''),
      at: Date.now()
    };
    try {
      window.sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(context));
    } catch (error) {}
  }

  function sanitizeDetail(detail) {
    var source = detail || {};
    var output = {};
    var forbidden = /^(email|customer_email|order_number|tracking_code|customer_name|address|message|query_text)$/i;

    Object.keys(source).forEach(function (key) {
      if (forbidden.test(key)) return;
      var value = source[key];
      if (typeof value === 'string') output[key] = clean(value);
      else if (typeof value === 'number' || typeof value === 'boolean' || value === null) output[key] = value;
    });
    return output;
  }

  function publish(name, detail) {
    if (!name) return;

    var safeDetail = sanitizeDetail(detail);
    var context = attribution();
    var payload = Object.assign({
      event: 'devidlabel_' + name,
      devid_event: name,
      measurement_version: '2',
      session_id: sessionId(),
      page_type: pageType(),
      path: clean(window.location.pathname),
      locale: clean(document.documentElement.lang || ''),
      customer_state: customerState()
    }, safeDetail);

    if (context) {
      if (!payload.attribution_surface) payload.attribution_surface = context.surface;
      if (!payload.attribution_handle && context.handle) payload.attribution_handle = context.handle;
    }

    window.dispatchEvent(new CustomEvent('devid:commerce-analytics', { detail: payload }));

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(payload);
    }

    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('devidlabel_' + name, payload);
      }
    } catch (error) {
      // Analytics must never interrupt the storefront experience.
    }
  }

  function trackSearch(detail) {
    if (!detail || !detail.event) return;

    var query = safeSearchQuery(detail.corrected_query || detail.query || '');
    var previousQuery = '';
    try {
      previousQuery = safeSearchQuery(window.sessionStorage.getItem(SEARCH_KEY) || '');
      if (query && /search_(results_rendered|zero_results|submitted)/.test(detail.event)) {
        window.sessionStorage.setItem(SEARCH_KEY, query);
      }
    } catch (error) {}

    var data = sanitizeDetail(detail);
    delete data.event;
    delete data.component;
    if (query) data.query = query;

    if (query && previousQuery && query !== previousQuery && /search_(results_rendered|zero_results|submitted)/.test(detail.event)) {
      data.previous_query = previousQuery;
      data.reformulated = true;
    }

    if (detail.event === 'search_product_clicked') {
      rememberAttribution('search', {
        handle: detail.handle || detail.product_handle || '',
        destination: detail.destination || detail.url || ''
      });
    }

    publish(detail.event, data);
  }

  function trackAssistant(detail) {
    if (!detail || !detail.event) return;

    if (detail.event === 'assistant_opened') {
      publish('assistant_opened', { source: 'assistant_runtime' });
      return;
    }

    if (detail.event === 'assistant_response_received') {
      var responseData = {
        response_type: detail.response_type || '',
        intent: detail.intent || '',
        has_products: Boolean(detail.has_products),
        order_status: detail.order_status || ''
      };
      publish('assistant_response_received', responseData);

      if (responseData.order_status) {
        publish('assistant_resolved', {
          intent: responseData.intent || 'order',
          resolution_type: 'order_status'
        });
      } else if (responseData.has_products && /^(product|look)$/i.test(responseData.intent || '')) {
        publish('assistant_resolved', {
          intent: responseData.intent,
          resolution_type: 'commerce_result'
        });
      } else if (/fallback|error/i.test(responseData.response_type || '')) {
        publish('assistant_fallback', {
          intent: responseData.intent,
          reason: 'response_type'
        });
      }
      return;
    }

    if (detail.event === 'assistant_error') {
      publish('assistant_error', { reason: detail.reason || 'request_failed' });
      publish('assistant_fallback', { reason: detail.reason || 'request_failed' });
      return;
    }

    if (detail.event === 'assistant_cta_clicked') {
      publish('assistant_cta_clicked', { response_type: detail.response_type || '' });
      return;
    }

    if (detail.event === 'assistant_tracking_clicked') {
      publish('assistant_tracking_clicked', { carrier: detail.carrier || '' });
      return;
    }

    if (detail.event === 'assistant_closed' || detail.event === 'assistant_reset') {
      publish(detail.event, {});
    }
  }

  function itemHasBundle(item) {
    return Boolean(item && item.properties && item.properties._bundle_id);
  }

  function trackVariantAdd(event) {
    var detail = event && event.detail ? event.detail : {};
    var items = Array.isArray(detail.items) ? detail.items : [];
    var hasBundle = items.some(itemHasBundle);
    var context = attribution();
    publish('add_to_cart', {
      source_surface: context ? context.surface : (hasBundle ? 'bundle' : 'pdp'),
      item_count: items.length || 1,
      has_bundle: hasBundle,
      cart_item_count: detail.cart && detail.cart.item_count ? detail.cart.item_count : 0,
      cart_value: detail.cart && typeof detail.cart.total_price === 'number' ? detail.cart.total_price : 0
    });
  }

  window.addEventListener('devid:search-v2', function (event) {
    trackSearch(event.detail || {});
  });

  window.addEventListener('devid:assistant', function (event) {
    trackAssistant(event.detail || {});
  });

  window.addEventListener('devid:wishlist', function (event) {
    var detail = event.detail || {};
    if (!detail.event) return;
    var data = sanitizeDetail(detail);
    delete data.event;
    if (detail.event === 'wishlist_product_clicked') {
      rememberAttribution('wishlist', {
        handle: detail.handle || '',
        destination: detail.destination || ''
      });
    }
    publish(detail.event, data);
  });

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target : null;
    if (!target) return;

    var assistantTarget = target.closest('[data-devid-assistant-v2] *');
    if (assistantTarget) {
      var action = assistantTarget.closest('[data-assistant-action]');
      if (action) {
        publish('assistant_quick_action', {
          intent: action.getAttribute('data-assistant-action') || 'unknown'
        });
        return;
      }

      var productLink = assistantTarget.closest('[data-assistant-product-link], .devid-assistant-commerce-card a[href*="/products/"], .devid-assistant-v2__product a[href*="/products/"]');
      if (productLink) {
        var href = productLink.getAttribute('href') || '';
        var handleMatch = href.match(/\/products\/([^/?#]+)/);
        var handle = handleMatch ? handleMatch[1] : '';
        rememberAttribution('assistant', { handle: handle, destination: href });
        publish('assistant_product_clicked', {
          destination: href,
          handle: handle
        });
        return;
      }
    }

    var checkout = target.closest('[name="checkout"]');
    if (checkout && !checkout.closest('#cart-drawer')) {
      publish('cart_checkout_clicked', {
        source: 'cart_page'
      });
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('[data-assistant-form]')) return;
    var input = form.querySelector('[data-assistant-input]');
    var value = input ? input.value.trim() : '';

    // Never send assistant text. Length is enough to diagnose composer friction.
    publish('assistant_message_sent', {
      message_length: value.length,
      source: 'composer'
    });
  }, true);

  document.addEventListener('variant:add', trackVariantAdd, true);

  window.DevidCommerceAnalytics = {
    publish: publish,
    sessionId: sessionId,
    rememberAttribution: rememberAttribution,
    attribution: attribution,
    pageType: pageType
  };
})();